import "../components/table.css";
import { formatDateTime } from "../utils/formatDate";
 
const Table = ({
  columns = [],
  data = [],
  loading = false,
  emptyMessage = "No records found.",
  itemsPerPage,
  pagination = null,
  onRowClick,
}) => {
  return (
    <>
      <div
        className={`table-responsive table-fixed-header overflow-auto ${
          itemsPerPage >= 20 ? "mb-80" : itemsPerPage > 11 ? "mb-3" : ""
        }`}
      >
        <table
          className={`table table-bordered table-hover ${
            itemsPerPage >= 20 ? "mb-3" : itemsPerPage < 11 ? "mb-0" : ""
          }`}
        >
          <thead className="table-light">
            <tr>
              {columns.map((col, index) => (
                <th key={index} style={col.style || {}}>
                  {col.label}
                </th>
              ))}
            </tr>
          </thead>
 
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={columns.length} className="text-center">
                  Loading...
                </td>
              </tr>
            ) : data.length === 0 ? (
              <tr>
                <td colSpan={columns.length} className="text-center">
                  {emptyMessage}
                </td>
              </tr>
            ) : (
              data.map((row, index) => (
                <tr
                  key={
                    row.id ||
                    row.enq_id ||
                    row.booking_id ||
                    row.user_id ||
                    row.country_code ||
                    index
                  }
                  onClick={() => onRowClick?.(row, index)}
                  style={{
                    cursor: onRowClick ? "pointer" : "default",
                  }}
                >
                  {columns.map((col, colIndex) => (
                    <td key={colIndex} style={col.tdStyle || {}}>
                      {col.render
                        ? col.render(row, index)
                        : col.isDate
                        ? formatDateTime(row[col.accessor])
                        : row[col.accessor] || "-"}
                    </td>
                  ))}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
 
      {pagination}
    </>
  );
};
 
export default Table;